import { store } from 'react-notifications-component';
import 'react-notifications-component/dist/theme.css';
import 'animate.css';

const addNotification = (status) => {
  switch (status) {
    case 'login-success': {
      store.addNotification({
        title: 'Welcome Chief',
        message: 'Welcome on board mister President !',
        type: 'success',
        container: 'bottom-left',
        animationIn: ['animated', 'fadeIn'],
        animationOut: ['animated', 'fadeOut'],
        dismiss: {
          duration: 5000,
          showIcon: true,
        },
      });
      break;
    }
    case 'login-error': {
      store.addNotification({
        title: 'Attention please, attention please',
        message: 'Hum, seems we got trouble chief !',
        type: 'danger',
        container: 'bottom-left',
        animationIn: ['animated', 'fadeIn'],
        animationOut: ['animated', 'fadeOut'],
        dismiss: {
          duration: 5000,
          showIcon: true,
        },
      });
      break;
    }
    case 'addEntry-success': {
      store.addNotification({
        title: 'Congrat\'s Dude',
        message: 'Picture\'s infos are register !',
        type: 'success',
        container: 'bottom-left',
        animationIn: ['animated', 'fadeIn'],
        animationOut: ['animated', 'fadeOut'],
        dismiss: {
          duration: 5000,
          showIcon: true,
        },
      });
      break;
    }
    case 'addEntry-error': {
      store.addNotification({
        title: 'Dude',
        message: 'Hum, seems we got trouble with creation entry !',
        type: 'danger',
        container: 'bottom-left',
        animationIn: ['animated', 'fadeIn'],
        animationOut: ['animated', 'fadeOut'],
        dismiss: {
          duration: 5000,
          showIcon: true,
        },
      });
      break;
    }
    case 'modifyEntry-success': {
      store.addNotification({
        title: 'Congrat\'s Dude',
        message: 'Picture\'s infos are well modify !',
        type: 'success',
        container: 'bottom-left',
        animationIn: ['animated', 'fadeIn'],
        animationOut: ['animated', 'fadeOut'],
        dismiss: {
          duration: 5000,
          showIcon: true,
        },
      });
      break;
    }
    case 'modifyEntry-error': {
      store.addNotification({
        title: 'Dude',
        message: 'Hum, seems we got trouble with modification !',
        type: 'danger',
        container: 'bottom-left',
        animationIn: ['animated', 'fadeIn'],
        animationOut: ['animated', 'fadeOut'],
        dismiss: {
          duration: 5000,
          showIcon: true,
        },
      });
      break;
    }
    case 'deleteEntry-success': {
      store.addNotification({
        title: 'Congrat\'s Dude',
        message: 'Picture\'s is deleted !',
        type: 'success',
        container: 'bottom-left',
        animationIn: ['animated', 'fadeIn'],
        animationOut: ['animated', 'fadeOut'],
        dismiss: {
          duration: 5000,
          showIcon: true,
        },
      });
      break;
    }
    case 'deleteEntry-error': {
      store.addNotification({
        title: 'Dude',
        message: 'Hum, seems we got trouble with delete entry !',
        type: 'danger',
        container: 'bottom-left',
        animationIn: ['animated', 'fadeIn'],
        animationOut: ['animated', 'fadeOut'],
        dismiss: {
          duration: 5000,
          showIcon: true,
        },
      });
      break;
    }
    case 'init-error': {
      store.addNotification({
        title: 'Data loading failed',
        message: 'Unable to load application data from the API.',
        type: 'warning',
        container: 'bottom-left',
        animationIn: ['animated', 'fadeIn'],
        animationOut: ['animated', 'fadeOut'],
        dismiss: {
          duration: 5000,
          showIcon: true,
        },
      });
      break;
    }
    default: {
      store.addNotification({
        title: 'Little attention please',
        message: 'Can you retry, or call an Administrator, Nooooow!',
        type: 'info',
        container: 'bottom-left',
        animationIn: ['animated', 'fadeIn'],
        animationOut: ['animated', 'fadeOut'],
        dismiss: {
          duration: 3000,
          showIcon: true,
        },
      });
      break;
    }
  }
};

export default addNotification;
